import type { WidgetSize } from "../../types/widget.types";

/**
 * Get CSS Grid Column Span for Widget Size
 * Optimized for better width utilization within sections
 * Grid has 2-4 columns, so widgets should use appropriate spans
 *
 * @param size
 *
 * @returns CSS class string for column span
 *
 */
export function getWidgetColSpan(size: WidgetSize): string {
  const spans = {
    // Large: Full width in 2-column grid, or 2/3 in 3-column grid
    large: "col-span-1 sm:col-span-2",
    // Medium: Full width in 2-column grid (when sections are side-by-side)
    // Takes 2 columns = full width of the section
    medium: "col-span-1 sm:col-span-2",
    // Small: 1 column - allows multiple widgets side by side
    small: "col-span-1",
    // XLarge: Always full width
    xlarge: "col-span-1 sm:col-span-2",
  } as const;

  return spans[size];
}

/**
 * Get CSS Grid Row Span for Widget Size
 *
 * @param size
 *
 * @returns CSS class string for row span
 *
 */
export function getWidgetRowSpan(size: WidgetSize): string {
  const spans = {
    large: "row-span-2",
    medium: "row-span-1",
    small: "row-span-1",
    xlarge: "row-span-2",
  } as const;

  return spans[size];
}
